module.exports = __webpack_public_path__ + "img/title.72b83d9a.png";